import React, { useEffect, useMemo } from 'react';
import { navigate } from 'gatsby';
import { TabDisconnected, Splash } from '../../components';
import { useOAT } from '../oatProvider';
import { useConfig } from '../configProvider';

export const allowedRoutes = ['join-table', 'home', 'faqs', 'tab-disconnected'];

interface OatNavigationProps {
  children: JSX.Element;
}

const OatNavigation = ({ children }: OatNavigationProps) => {
  const { page = '', states = [], getPagePath, restaurantId } = useConfig();

  const { currentState, setIsLoading, isLoading, isRedundant } = useOAT();

  const shouldStopLoading = useMemo(() => {
    const isAllowedRoute = allowedRoutes.includes(page) && !restaurantId;

    const pages = states.filter((state) => state?.pages?.includes(page));

    const hasMatchingState = pages.find((state) => state?.name === currentState);

    return hasMatchingState || isAllowedRoute;
  }, [states, restaurantId, page, currentState]);

  if (currentState) {
    const { pages } = states.find((state) => state?.name === currentState) || {};
    if (!pages?.includes(page) && pages?.[0]) {
      const pagePath = getPagePath(pages[0]);
      navigate(pagePath, { replace: true });
    }
  }

  useEffect(() => {
    if (shouldStopLoading) {
      setIsLoading(false);
    }
  }, [shouldStopLoading, setIsLoading]);

  if (isLoading || !shouldStopLoading) {
    return <Splash />;
  }

  if (isRedundant) {
    return <TabDisconnected />;
  }

  return children;
};

export default OatNavigation;
